var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakhalophDesktopLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 33.6209H22.45L13.7725 39.6557C12.4855 40.5527 10.75 39.5946 10.75 37.9636V33.6209C4.9 33.6209 1 29.5433 1 23.4269V11.194C1 5.0776 4.9 1 10.75 1H30.25C36.1 1 40 5.0776 40 11.194V23.4269C40 29.5433 36.1 33.6209 30.25 33.6209Z",
    fill: "white",
    stroke: "#0008C3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakhalophDesktopLogo);
export default __webpack_public_path__ + "static/media/takhalophDesktopLogo.0c7b0a9a5137c9c82ed7037382745451.svg";
export { ForwardRef as ReactComponent };